import { render, staticRenderFns } from "./ItemPartida.vue?vue&type=template&id=222a6266&scoped=true&"
import script from "./ItemPartida.vue?vue&type=script&lang=js&"
export * from "./ItemPartida.vue?vue&type=script&lang=js&"
import style0 from "./ItemPartida.vue?vue&type=style&index=0&id=222a6266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a6266",
  null
  
)

export default component.exports